import RuleList from 'alertRules/components/RuleList';
import { RuleAccordionProps } from 'alertRules/components/RuleAccordion';

type Props = {
  data: RuleAccordionProps[];
  isLoading: boolean;
};

const AlertRulesList = ({ data, isLoading }: Props) => (
  <RuleList
    data={data}
    isLoading={isLoading}
    emptyStateTitle="Create your first alert rule"
    emptyStateDescription="Ex: send all failure alerts to #failure-alerts-channel"
  />
);

export default AlertRulesList;
